import { render, staticRenderFns } from "./relation-tag.vue?vue&type=template&id=3c1ae382&scoped=true"
import script from "./relation-tag.vue?vue&type=script&lang=js"
export * from "./relation-tag.vue?vue&type=script&lang=js"
import style0 from "./relation-tag.vue?vue&type=style&index=0&id=3c1ae382&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1ae382",
  null
  
)

export default component.exports